import consumer from "./consumer"
window.consumer = consumer;
